import { gql } from "lib/apolloClient";

export const learningCourseFeedFragment = gql`
  fragment learningCourseItem on LearningCourse {
    id
    type
    title
    state
    code
    academicCourse {
      id
      label
      code
    }
    includeAllGradingPeriods
    gradingPeriods {
      edges {
        node {
          id
          label
        }
      }
    }
    isArchived
    displayName
    displayMetadata
    classes(filters: $classesFilters) {
      id
      title
    }
    subjects {
      id
      name
    }
    grades(filters: $gradeFilters) {
      id
      name
    }
    subjectGroup {
      id
      name
    }
    createdBy {
      id
      type
      firstName
      middleName
      lastName
      profileImage
    }
    collaborators(filters: $collaboratorFilters) {
      totalCount
      edges {
        node {
          id
          type
          firstName
          middleName
          lastName
          preferredName
          prefix
          suffix
          pronouns
          profileImage
        }
      }
    }
    childCourses(filters: { status: ACTIVE }) {
      id
      title
      displayMetadata
    }
  }
`;

export const gradeFragment = gql`
  fragment gradeItem on Grade {
    id
    name
    globalGrade {
      id
      uid
      name
      constants
    }
    curriculumProgram {
      id
      type
      nodeInterfaceType
      label
      acronym
      academicSetupType
    }
    displaySequence
  }
`;

export const learningCourseListItem = gql`
  fragment learningCourseListItem on LearningCourse {
    id
    title
    isArchived
    displayMetadata
    childCourses {
      id
    }
    grades {
      id
    }
    subjects {
      id
    }
    gradingPeriods {
      edges {
        node {
          id
          label
          startDate
          endDate
          academicYear {
            id
            startDate
            endDate
          }
        }
      }
    }
    responseLanguage {
      id
    }
    academicYears {
      id
    }
    associatedLevels {
      id
      label
      type
    }
    subjectLevelMap {
      subject {
        id
      }
      associatedLevels {
        id
      }
    }
    academicCourse {
      id
      students(filters: $academicCourseStudentsFilters) {
        id
      }
    }
  }
`;

export const blueprintCourseFeedFragment = gql`
  fragment learningCourseItem on LearningCourse {
    id
    type
    title
    state
    code
    academicCourse {
      id
      label
      code
    }
    includeAllGradingPeriods
    gradingPeriods {
      edges {
        node {
          id
          label
        }
      }
    }
    isArchived
    displayName
    displayMetadata
    subjects {
      id
      name
    }
    grades(filters: $gradeFilters) {
      id
      name
    }
    subjectGroup {
      id
      name
    }
    createdBy {
      id
      type
      firstName
      middleName
      lastName
      profileImage
    }
    collaborators(filters: $collaboratorFilters) {
      totalCount
      edges {
        node {
          id
          type
          firstName
          middleName
          lastName
          preferredName
          prefix
          suffix
          pronouns
          profileImage
        }
      }
    }
  }
`;
